
import { Vue } from "vue-class-component";

export default class Coin extends Vue {}
